import { lazy, Suspense, type FC, type CSSProperties } from 'react';
import { useClientState } from 'dibs-react-hooks/exports/useClientState.ts';

const ModelViewerLazy = lazy(
    () => import(/* webpackChunkName: "ModelViewer" */ 'dibs-model-viewer/exports/ModelViewer.ts')
);

export type ModelViewerProps = {
    src: string;
    posterSrc?: string | null;
    style: CSSProperties;
    className?: string;
    autoRotate?: boolean;
    onLoad?: () => void;
};

export const NftModelViewerLazy: FC<ModelViewerProps> = props => {
    const isClient = useClientState();
    return isClient ? (
        <Suspense fallback={null}>
            <ModelViewerLazy {...props} />
        </Suspense>
    ) : null;
};
